import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { Form } from "antd";

import {
  fetchTaxReceiptLogs,
  downloadTaxReceipt,
  regenerateTaxReceipt,
  generateTaxReceipt,
  cancelTaxReceipt,
  resendTaxReceipt,
  fetchTaxReceiptConfiguration
} from '../../taxReceiptActions';

import TaxReceiptPanel from './TaxReceiptPanel';

const mapStateToProps = state => ({
  taxReceiptFieldDisplay: state.TaxReceipt.taxReceiptFieldDisplay,
  logs: state.TaxReceipt.taxReceiptLogs,
  isDownloadInProgress: state.TaxReceipt.isDownloadInProgress,
  isCancelInProgress: state.TaxReceipt.isCancelInProgress,
  isRegenerateInProgress: state.TaxReceipt.isRegenerateInProgress,
  isGenerateInProgress: state.TaxReceipt.isGenerateInProgress,
  isResendInProgress: state.TaxReceipt.isResendInProgress,
  configuration: state.TaxReceipt.taxReceiptConfiguration,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchTaxReceiptLogs,
  downloadTaxReceipt,
  regenerateTaxReceipt,
  generateTaxReceipt,
  cancelTaxReceipt,
  resendTaxReceipt,
  fetchTaxReceiptConfiguration
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  Form.create(),
)(TaxReceiptPanel);
